import PropTypes from "prop-types";
import classnames from "classnames";

const StatTile = ({ label, value, hint, icon: Icon, valueClassName, children }) => (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
        <div className="flex items-center justify-between text-xs text-muted">
            <span className="font-medium uppercase tracking-wider">{label}</span>
            {Icon && <Icon className="h-4 w-4" />}
        </div>
        <p className={classnames("mt-2 text-2xl font-semibold tracking-tight text-gray-900", valueClassName)}>{value}</p>
        {hint && <p className="mt-1 text-xs text-muted">{hint}</p>}
        {children}
    </div>
);

StatTile.propTypes = {
    label         : PropTypes.string.isRequired,
    value         : PropTypes.node,
    hint          : PropTypes.node,
    icon          : PropTypes.elementType,
    valueClassName: PropTypes.string,
    children      : PropTypes.node
};

export default StatTile;
